// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2PGK5","empty":"ModalGraph_empty__33nSf"};